import React, { useState, useEffect } from "react";
import { useAuth } from "../../AuthContext";
import Axios from 'axios';
import { json, useNavigate, useParams } from "react-router-dom";
import ImageList from '@mui/material/ImageList';
import ImageListItem from '@mui/material/ImageListItem';
import { MdLocationOn } from "react-icons/md";
import { FaPlus } from "react-icons/fa6";
import FillerImage from "../../assets/filler-image.jpg";
import Navbar from "../../components/Navbar.js";
import Stars from "../../components/Stars.js"
import ReviewComponent from "../../components/ReviewComponent.js";


function DetailView() {
    console.log("DetailView component rendered");
    const sampleId = useParams().data;
    const { loggedIn, user } = useAuth();
    console.log(user.id)

    const navigate = useNavigate();
    const [LogoImage, setLogoImage] = useState(FillerImage);
    const [MainImage,setMainImage] = useState(FillerImage);
    const [BuildingName,setBuildingName] = useState();
    const [CollegeName, setCollegeName] = useState();
    const [BathroomName, setBathroomName] = useState();
    const [BathroomFloor, setBathroomFloor] = useState();
    const [BathroomAddress, setBathroomAddress] = useState();
    const [BathroomRating, setBathroomRating] = useState(0);
    const [BathroomReviewCount, setBathroomReviewCount] = useState(0);
    const [dynamicBathroomQualities, setDynamicBathroomQualities] = useState([]);

    const [userData, setUserData] = useState([]);
    const [data, setData] = useState([]);

    useEffect(() => {
        console.log("Fetching bathroom details...");

        const fetchData = async () => {
            try {
                const res = await fetch(`https://uplbidet-api.vercel.app/api/cr/${sampleId}`);
                if (!res.ok) throw new Error("An error has occurred.");

                const jsonData = await res.json();
                setData(jsonData);
                setMainImage(jsonData.interior_photo);
                setBuildingName(jsonData?.building?.toUpperCase());
                setCollegeName(jsonData?.college?.toUpperCase());
                setBathroomName(jsonData.name);
                setBathroomFloor(jsonData.floor);
                setBathroomAddress(jsonData.description);
                setBathroomRating(jsonData.average_rating);
                setDynamicBathroomQualities(jsonData.tags);

                

                // Fetch logo image after data is fetched
                try {
                    if (jsonData) {
                        setLogoImage(
                            (await import(`../../assets/colleges/${jsonData.college.toUpperCase()}.png`)).default
                        );
                    }
                } catch (error) {
                    console.error("Error fetching logo image: ", error);
                    setLogoImage(FillerImage); // Handle the error or set a default image
                }

                // Fetch user data using user.id from the useAuth() hook
                try {
                    const userResponse = await fetch(`https://uplbidet-api.vercel.app/api/users/${user.id}`);
                    if (!userResponse.ok) throw new Error("An error has occurred while fetching user data.");

                    setUserData(await userResponse.json());
                } catch (error) {
                    console.error("Error fetching user data: ", error);
                    setUserData({}); // Handle the error or set a default user data
                }
            } catch (error) {
                console.error("Error fetching data: ", error);
            }
        };

        fetchData();
    }, [sampleId, user.id]);

    console.log(BathroomRating)
    console.log(userData)
    console.log(data)

    const [reviews, setReviews] = useState([]);
    useEffect(() => {
        console.log("Fetching reviews...");
        const fetchReviews = async () => {
          try {
            const res = await fetch(`https://uplbidet-api.vercel.app/api/reviews/cr/${sampleId}`);
            if (!res.ok) {
              throw new Error("An error has occured.");
            }
    
            const jsonReviews = await res.json();
            const reviewPromise =  jsonReviews.map(async (review) =>  {
                        const res = await fetch(`https://uplbidet-api.vercel.app/api/users/${review.user_id}`);
                        const user = await res.json();
                        console.log(user._id,user.username,"This is a trial");
                        review.userName = user.username;
                        review.logo = user.user_image;
                    });

            await Promise.all(reviewPromise);
            console.log(jsonReviews,"Add")
            setReviews(jsonReviews);
            setBathroomReviewCount(jsonReviews.length)
          } catch (error) {
            console.error("Error fetching reviews: ", error);
          }
        };
            fetchReviews();
        }, []
    );

    console.log(reviews)

    const getOrdinalNumber = (number) => {
        const suffixes = ["th", "st", "nd", "rd"];
        const v = number % 100;
        return number + (suffixes[(v - 20) % 10] || suffixes[v] || suffixes[0]);
    };
    
    // const MainImage = data?.main_photo;
    // const BuildingName = data?.building?.toUpperCase()
    // const CollegeName = data?.college?.toUpperCase()
    // const LogoImage = (`../../assets/colleges/${CollegeName}.png`);
    // const BathroomName = data?.name
    // const BathroomFloor = data?.floor?.toUpperCase()
    // const BathroomAddress = data?.description
    // const BathroomRating = data?.average_rating
    // const BathroomReviewCount = reviews?.length

    /* to modify these arrays, just change the attribute name(e.g., quality, count) 
       inside the map function below, then use the array name as the name 
       of the passed array */
    // const BathroomQualities = 
    //     // [
    //     //     { quality: 'IG Worthy', count: 10 },
    //     //     { quality: 'Clean', count: 8 },
    //     //     { quality: 'No Smell', count: 5 },
    //     // ]
    //     (data && data.tags || [])
    //     // []
    //   ;
    

    
    console.log(dynamicBathroomQualities)  
    var newLabel; 

    // const [newLabel, setNewLabel] = useState("")

    const handleTagButtonClick = async (index) => {
        let updatedQualities = dynamicBathroomQualities
        var updatedFields = {
            user_id: user.id,
            cr_id: sampleId,
            new_tag: "",
        }
        
        if (index === -1){
            // Prompt user for the label of the new instance
            newLabel = (prompt('Enter new tag:'))
            if (newLabel) {
                updatedQualities = [
                    ...updatedQualities,
                    { tag: newLabel, users: [user.id] },
                  ];

                updatedFields.new_tag = newLabel

                // const response = await Axios.post(`https://uplbidet-api.vercel.app/api/cr/tag`, updatedFields);
                // console.log(response)

                setDynamicBathroomQualities(updatedQualities)
            }
        } 
        else {
            const updatedQualities = dynamicBathroomQualities.map((item, i) => {
                if (i === index && (index >= 0 && index <= dynamicBathroomQualities.length - 1)) {
                    updatedFields.new_tag = item.tag
                    console.log(updatedFields.new_tag)
                    const updatedUsers = item.users.includes(user.id)
                        ? item.users.filter((element) => element !== user.id)
                        : [...item.users, user.id];

                    
                    return {
                        ...item,
                        users: updatedUsers,
                    };
                } else {
                    return item;
                }

            });

            setDynamicBathroomQualities(updatedQualities)
        }

        const response = await Axios.post(`https://uplbidet-api.vercel.app/api/cr/tag`, updatedFields);
        console.log(response)
    };


    const detailsTable = [
        { attribute: 'BIDET', classification: data.bidet},
        { attribute: 'TISSUE PAPER', classification: data.tissue_paper},
        { attribute: 'SOAP', classification: data.soap },
        { attribute: 'HAND DRYER', classification: data.hand_dryer },
        { attribute: 'CLASS', classification: data.type },
      ];
    // const imageSources = [
    //     {img: FillerImage, rows: 1, cols: 6,},
    //     {img: FillerImage, rows: 1, cols: 2,},
    //     {img: FillerImage, rows: 1, cols: 2,},
    //     {img: FillerImage, rows: 1, cols: 2,},
    //     {img: FillerImage, rows: 1, cols: 3,},
    //     {img: FillerImage, rows: 1, cols: 3,},
    // ];

    const imageSources = reviews.map((review, index) => ({
        img: review.review_photo,
        rows: 1,
        cols: Math.min(3, Math.ceil(reviews.length / 3)) * 2 || 6,
      }));

    const handleUpdateButtonClick = () => {
        navigate(`/update-detail/${sampleId}`);
      };

    const handleReviewButtonClick = () => {
        navigate(`/add-review/${sampleId}`);
    };

    const ReviewsArray = reviews;

  return (
    <>
        <Navbar passedState={loggedIn} user={user} />
        <div className="main-content">
            <div className="workable-area">
                <div className="portion-container">
                    <div className="image-container">
                        <img
                            src={MainImage} 
                            width={300}
                            height={350}
                            padding={10}
                            alt="Image of a bathroom"
                            style={{
                                boxShadow: '0 4px 8px rgba(0, 0, 0, 0.5)'
                            }}
                        />

                    </div>

                    <div className="horizontal-flex" >
                        
                        <img 
                            className="logo-style"
                            src={LogoImage}
                            width={75}
                            height={75}
                            alt="This is a logo"
                        />

                        <div className="bathroom-info"> 
                        <span style={{
                            fontFamily: 'Roboto, sans-serif',
                            fontSize: 40,
                        }}>
                            {BuildingName}
                        </span>
                            <span style={{
                                fontFamily: 'Roboto, sans-serif',
                                fontSize: 25,
                            }}>
                                {CollegeName}
                            </span>
                            <span>
                                <i>
                                    {BathroomName}, {isNaN(Number(BathroomFloor)) ? BathroomFloor : getOrdinalNumber(BathroomFloor)} Floor, {BathroomAddress}
                                </i>
                            </span>
                                <span className="new-vertical-flex" style={{marginTop: '5px',}}>
                                    <div className="category-widget">
                                        <div>
                                            RATING:  

                                        </div>
                                        <div style={{color:'gray', paddingLeft:'5px'}}>
                                            <Stars averageRating={BathroomRating} /> 
                                            ({BathroomRating}/5 stars)
                                        </div>
                                    </div>
                                    <div className="category-widget">
                                        <div>
                                            NUMBER OF REVIEWS:

                                        </div>
                                        <div style={{color:'gray', paddingLeft:'25px'}}>
                                            {BathroomReviewCount}
                                        </div>
                                    </div>
                                </span>
                            <span className="row-container" style={{marginTop: '5px',}}>
                                {dynamicBathroomQualities.map((item, index) => (
                                    <button className="oval-button" onClick={() => handleTagButtonClick(index)}>
                                        <div className="text-padding">
                                            {`${item.tag} (${item.users.length})`}
                                        </div>
                                    </button>
                                ))}
                                
                                <button className="oval-button" onClick={() => handleTagButtonClick(-1)}>
                                    <div className="text-padding">
                                        +
                                    </div>
                                </button>
                            </span>

                            <span className="horizontal-flex" style={{marginTop: '10px', justifyContent: 'space-between', height: '100%'}}>
                                
                                <div className="new-vertical-flex" style={{justifyContent: 'space-between', width: '100%'}}>
                                    <div>DETAILS:</div>
                                    <table style={{ width: '100%' }}>
                                        <tbody>
                                        {detailsTable.map((detailsTable, index) => (
                                            <tr key={index} style={{ justifyContent:'space-between' }}>
                                                <td>{`• ${detailsTable.attribute}:     `}</td>
                                                <td style={{ paddingLeft: '5px', color: 'gray'}}>{
                                                    (detailsTable.classification === true ? 'YES' : 
                                                        (detailsTable.classification == false ? 'NO': 
                                                            (detailsTable.classification === 'pwd'? 'GENDER NEUTRAL AND PWD(s)' : 
                                                                detailsTable?.classification?.toUpperCase())))}
                                                </td>
                                            </tr>
                                        ))}
                                        </tbody>
                                    </table>
                                    </div>
                            </span>
                        </div>
                    </div>
                    <span className="new-vertical-flex" style={{maxHeight: '100vw', justifyContent: "space-between"}}>
                        <MdLocationOn size={90} color="maroon" />
                        <span className="horizontal-flex">
                            <button className="rectangular-button" onClick={handleUpdateButtonClick} style={{ display: loggedIn ? 'block' : 'none' }}>
                                <div className="text-padding">
                                    Update details
                                </div>
                                
                            </button>
                        </span>
                    </span>
                </div>
                <hr />
                <div className="portion-container">

                    {/* Bottom Portion */}
                    <div className="image-container">
                        <ImageList
                            sx={{ width: 310 }}
                            variant="quilted"
                            cols={6}
                        >
                            {imageSources.map((item, index) => (
                                <ImageListItem key={index} cols={item.cols || 1} rows={item.rows || 1}>
                                <img
                                    src={item.img}
                                    alt={item.title}
                                    loading="lazy"
                                />
                                </ImageListItem>
                            ))}
                        </ImageList>
                    </div>

                    <div className="bathroom-info" style={{width:'68%'}}>
                            <div className='horizontal-flex' style={{justifyContent: 'space-between'}}>
                                <span style={{
                                    fontFamily: 'Roboto, sans-serif',
                                    fontSize: 30,
                                }}>
                                    REVIEWS:
                                </span>
                                <span className="row-container">
                                    <button className="post-button" onClick={handleReviewButtonClick} style={{ display: loggedIn ? 'block' : 'none' }}>
                                        <div className="text-padding">
                                        <FaPlus /> ADD REVIEW
                                        </div>
                                    </button>

                                </span>

                            </div>  
                        {
                                ReviewsArray.length === 0 ? <span>No Reviews Yet</span> : 
                                (ReviewsArray.map((review) => (

                                    <ReviewComponent
                                        logo={review.logo}
                                        userName={review.userName}
                                        timePublished={review.time_published}
                                        reviewRating={review.overall_rating}
                                        comment={review.comment}
                                        likes={review.likes}
                                        reviewId = {review._id}
                                        userId = {user.id}
                                    />
                                )))
                        }
                        
                        {/* {ReviewsArray.map((review) => (

                            <ReviewComponent
                                logo={review.logo}
                                userName={review.userName}
                                timePublished={review.time_published}
                                reviewRating={review.overall_rating}
                                comment={review.comment}
                                likes={review.likes}
                            />
                        ))} */}
                    </div>
                </div>
            </div>
        </div>
    </>
    );
}

export default DetailView;
